import p from './role-manage.vue';

export default p;
